import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}

class FeaturesTiles extends React.Component {

  render() {

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,      
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      pushLeft,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'features-tiles section',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'features-tiles-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const tilesClasses = classNames(
      'tiles-wrap',
      pushLeft && 'push-left'
    );

    const sectionHeader = {
      title: 'Let Us Divide The Burden Together',
      HeaderColor:"#04AA6D",
      // paragraphColor:"#5091EE",
      paragraph: 'Products'
    };

    const Products=[
    {
      name:"SAND",
      icon:"",
      info:"WE ARE PROVIDING THE VARIETY OF SAND AS ACCORDING TO THE CONSUMER NEEDS. WITH ASSURED GUARANTY OF QUALITY AND QUANTITY"
    },
    {
      name:"STONES",
      icon:"",
      info:"STONES ARE AVALIABLE IN DIFFERENT SIZES. YOU CAN AVAIL. IT AS PER YOUR CONSTRUCTION NEED"
    },
    {
      name:"BRICKS",
      icon:"",
      info:"BLOCKS THAT ARE MADE TO BUILD UP YOUR DREAM SPACE.THESE ARE ALSO AVAILABLE IN DIFFERENT CATEGORIES"
    },
    {
      name:"SANITARY",
      icon:"",
      info:"AS WE ARE PROVIDING PLUMBING, DRAINAGE AND WATER MANAGEMENT SYSTEM AS PER YOUR NEEDS."
    },
    {
      name:"TILE ADHESIVE",
      icon:"",
      info:"FOR THE STRENGTH FIXTURE OF YOUR FLOORING AND WALLS TILE WE ARE PROVIDING CERTIFIED AND QUALITY ASSURED PRODUCTS"
    },
    {
      name:"TMT BARS",
      icon:"",
      info:"FOR THE STRUCTURE STRENGTH OF YOUR BUILDING APPROACH US.TO HAVE ALL KIND OF TMT Bars"
    },

    ]

    return (
      <section
        {...props}
        className={outerClasses}
      >
        <div className="container" id="featuretiles">
          <div className={innerClasses}>
            <SectionHeader data={sectionHeader}  className="center-content" />
            <div className={tilesClasses}>
            {
              Products.map((product)=>{
                return (
                  <div className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap">
                  <div className="tiles-item-inner">
                    <div className="features-tiles-item-header">
                      <div className="features-tiles-item-image mb-16">
                        {/* <Image
                          src={require('./../../assets/images/feature-tile-icon-01.svg')}
                          alt="Features tile icon 01"
                          width={64}
                          height={64} /> */}
                      </div>
                    </div>
                    <div className="features-tiles-item-content">
                      <h3 className="mt-0 mb-8 text-xl fw-600 "   style={{"color": "#5091EE"}}>
                        {product.name}
                      </h3>
                      <p className="m-0 text-sm">
                      {product.info}

                      </p>
                    </div>
                  </div>
                </div>
                )
              })
            }
            
       

            </div>
          </div>
        </div>
      </section>
    );
  }
}

FeaturesTiles.propTypes = propTypes;
FeaturesTiles.defaultProps = defaultProps;

export default FeaturesTiles;